import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button as PresetButton } from './ui/button';
import { Spinner } from './ui/spinner';
/** Роль действия → вариант пресета. */
const VARIANT = {
    primary: 'default',
    secondary: 'secondary',
    ghost: 'ghost',
    outline: 'outline',
    /* МЯГКИЙ ДЕСТРУКТИВ - решение владельца 2026-09-25: «ghost с красным
       значком». До единицы 15 здесь стоял `outline` пресета - нейтральная
       кнопка в рамке, то есть ни ghost, ни красная: запись решения и код
       разошлись. Красный даёт значок, класс ниже. */
    danger: 'ghost',
    'danger-solid': 'destructive',
};
/** Размер продукта → размер пресета. */
const SIZE = { l: 'lg', m: 'default', s: 'sm' };
/** То же для кнопки без подписи: у пресета для неё отдельный ряд размеров. */
const ICON_SIZE = { l: 'icon-lg', m: 'icon', s: 'icon-sm' };
export function Button({ variant = 'secondary', size = 'l', block = false, loading = false, disabled = false, type = 'button', icon, iconOnly = false, asChild = false, className, children, ...rest }) {
    /*
     * `asChild` ОТДАЁТ ВИД ССЫЛКЕ - и тогда ребёнок обязан быть РОВНО ОДИН.
     *
     * Slot базовой библиотеки требует единственного элемента: пара
     * «выражение + ребёнок» ломает его, и весь узел падает. Так пропала
     * целиком сетка падов - пустое состояние с кнопкой-ссылкой роняло
     * секцию, и ворота звука поймали это пятью сценариями сразу.
     */
    if (asChild) {
        return (_jsx(PresetButton, { ...rest, asChild: true, variant: VARIANT[variant], size: iconOnly ? ICON_SIZE[size] : SIZE[size], className: [block ? 'w-full' : '', className ?? ''].filter(Boolean).join(' ') || undefined, children: children }));
    }
    /*
     * ЗАБЛОКИРОВАННАЯ КНОПКА НЕ БЫВАЕТ ЗАЛИТОЙ. Решение владельца 2026-09-26
     * (5), доведённое до правила компонента единицей 21.
     *
     * Залитая главным цветом кнопка на половине прозрачности с расстояния
     * читается как активная, и человек жмёт в неё снова. Решение единица 19
     * применила к одной кнопке («Выйти в эфир») - повторный аудит нашёл ещё
     * пять таких же (N-01, N-18). Правило в месте вызова держится на
     * внимании; здесь оно держится само: `primary` вместе с `disabled` или
     * `loading` рисуется вариантом `secondary`.
     *
     * Прозрачность 0,5 - не признак. Причина недоступности пишется словами
     * рядом и связывается с кнопкой `aria-describedby`: это требуют ворота
     * `UI-10` (статически - `pnpm ui:check`, живьём -
     * `e2e/class-buttons.spec.ts`). Пометка `data-demoted` говорит
     * сценарию, что кнопка ГЛАВНАЯ по роли и понижена блокировкой.
     */
    const blocked = disabled || loading;
    const shown = variant === 'primary' && blocked ? 'secondary' : variant;
    return (_jsxs(PresetButton, { ...rest, type: type, variant: VARIANT[shown], "data-demoted": shown === variant ? undefined : 'primary', "data-danger": variant === 'danger' || variant === 'danger-solid' ? '' : undefined, size: iconOnly ? ICON_SIZE[size] : SIZE[size], 
        /* Классы места вызова - ТОЛЬКО РАСКЛАДКА: размещение, ширина, зазор.
           Цвет, рамка, радиус, тень, кегль сюда не попадут - это стережёт
           правило UI-3 (`pnpm ui:check`). */
        className: [
            block ? 'w-full' : '',
            /* Красный значок мягкого деструктива - токеном пресета. */
            variant === 'danger' ? '*:[svg]:text-destructive' : '',
            className ?? '',
        ]
            .filter(Boolean)
            .join(' ') || undefined, disabled: disabled || loading, "aria-busy": loading || undefined, children: [loading ? _jsx(Spinner, {}) : icon, children] }));
}
//# sourceMappingURL=Button.js.map